import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import StatisticsController from '@club/customer/api/StatisticsController'
import { route } from '@helpers'
import useRequestEffect from '@hooks/useRequestEffect'
import React from 'react'

export default function QuickLinks({ club }: Props) {
    const [statistics, setStatistics] = useRequestEffect(() => StatisticsController.show(club.id))

    if (!statistics)
        return null

    return (
        <Grid columns="3">
            <EmphasizedContent>
                <Grid gap="10px">
                    <h4>Members ({statistics.members})</h4>
                    <small>The list provides you with a basic info about the members of your group and their statistics.</small>
                    <Button type="tertiary" width="auto" to={route("club:owner:members")}>See all</Button>
                </Grid>
            </EmphasizedContent>
            <EmphasizedContent>
                <Grid gap="10px">
                    <h4>Discounts ({statistics.discounts})</h4>
                    <small>If given, discounts are available for all members of the group. They will be activated automatically when paid.</small>
                    <Button type="tertiary" width="auto" to={route("club:owner:discounts")}>See all</Button>
                </Grid>
            </EmphasizedContent>
            <EmphasizedContent>
                <Grid gap="10px">
                    <h4>Salons ({statistics.salons})</h4>
                    <small>The salons where the members of your group are participating or participated earlier.</small>
                    <Button type="tertiary" width="auto" to={route("club:owner:salons")}>See all</Button>
                </Grid>
            </EmphasizedContent>
        </Grid>
    )
}

interface Props {
    club: Resources.Club
}